import './content-sources.css';

import {div} from '../../src/utils/html.ts';
import type {ContentSourceData, ContentSourceListingData} from '../../types/types.ts';
import {render as resourceStar} from '../components/wc/resource-star.ts';
import {createElement} from '../lib/dom.ts';

const supportedSourceNames = ['DN Public Feed', 'ncp2-aptoma', 'acs-digital-utgave'];

export async function renderContentSourcesPage(appEl: HTMLElement, data: ContentSourceListingData[]) {
	const pageEl = createElement(appEl.ownerDocument, 'div', 'content-sources');
	appEl.appendChild(pageEl);

	pageEl.innerHTML = '<div><a href="/home">Home</a> | Content sources</div>';

	renderContentSources(pageEl, data);
}

export async function renderContentSourcePage(appEl: HTMLElement, contentSource: ContentSourceData) {
	const pageEl = createElement(appEl.ownerDocument, 'div', 'content-sources');
	appEl.appendChild(pageEl);

	pageEl.innerHTML = '<div><a href="/home">Home</a> | <a href="/feed">Content sources</a></div>';

	const contentSourceEl = createElement(appEl.ownerDocument, 'div', 'content-source');

	contentSourceEl.innerHTML = `
		${contentSource.attributes.queries
			.sort((a, b) => a.title.localeCompare(b.title, 'no'))
			.map((query) => {
				const id = `${contentSource.id}-${query.id}`;
				const label = `${query.title} (${contentSource.attributes.title})`;
				const path = `/feed/${id}`;

				return div(`<a href="${path}">${query.title}</a>
				${resourceStar({
					type: 'feed',
					id,
					label,
					path
				})}`);
			})
			.join('\n')}
`;

	pageEl.appendChild(contentSourceEl);
}

export function renderContentSources(targetEl: HTMLElement, data: ContentSourceListingData[]) {
	data.forEach((contentSource) => {
		if (!supportedSourceNames.includes(contentSource.attributes.sourceName)) {
			return;
		}
		const contentSourceEl = createElement(targetEl.ownerDocument, 'div', 'content-source');
		contentSourceEl.innerHTML = `<a href="/feed/${contentSource.id}">${contentSource.attributes.title}</a>`;
		targetEl.appendChild(contentSourceEl);
	});
}
